const mapToIds = popups => Object.values(popups).map(popup => popup.id);

export default mapToIds;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/mapToIds.jsx